import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Image, Badge } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      soc: false
    }
  }

  changeSoc = () => {
    this.setState({
      soc: !this.state.soc
    })
  }

  render() {

    const { changeLeftMenuh, changeTopSearch, favorite, cart, page_data } = this.props,
    { soc } = this.state

    return (
      <div className={styles.mob_fenu}>
        <div className={soc ? styles.mob_fenu_icons_active : styles.mob_fenu_icons}>
          <div onClick={this.changeSoc} className={styles.mob_fenu_icons_head}>
            {soc ?
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L11 11" stroke="white"/>
                <path d="M11 1L1 11" stroke="white"/>
              </svg>
            :
              <svg className={styles.mob_fenu_icons_open} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_332_10301)">
                  <path d="M4.90412 14.5685C5.94312 15.1677 7.14862 15.5105 8.4342 15.5105C12.3422 15.5105 15.5106 12.3425 15.5106 8.43449C15.5106 4.52647 12.3425 1.3584 8.43449 1.3584C4.52647 1.3584 1.3584 4.52647 1.3584 8.43449C1.3584 9.7201 1.70123 10.9256 2.30046 11.9646L2.30278 11.9686C2.36043 12.0686 2.38951 12.119 2.40268 12.1666C2.4151 12.2116 2.41857 12.2519 2.41539 12.2985C2.41197 12.3484 2.39513 12.4003 2.36059 12.5038L1.75612 14.3173L1.75536 14.3197C1.62782 14.7023 1.56405 14.8936 1.60951 15.021C1.64914 15.1322 1.73711 15.2199 1.84826 15.2595C1.97545 15.3049 2.16589 15.2414 2.54682 15.1144L2.55157 15.1127L4.36499 14.5082C4.46824 14.4738 4.52073 14.4563 4.57062 14.4529C4.61713 14.4497 4.65725 14.4539 4.70219 14.4664C4.74995 14.4796 4.80039 14.5087 4.90087 14.5666L4.90412 14.5685Z" fill="white" stroke="#5C5C5C" strokeLinecap="round" strokeLinejoin="round"/>
                  <path className={styles.mob_fenu_icons_open_t1} d="M5.5 9C5.77614 9 6 8.77614 6 8.5C6 8.22386 5.77614 8 5.5 8C5.22386 8 5 8.22386 5 8.5C5 8.77614 5.22386 9 5.5 9Z" fill="#5C5C5C"/>
                  <path className={styles.mob_fenu_icons_open_t2} d="M8.5 9C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8C8.22386 8 8 8.22386 8 8.5C8 8.77614 8.22386 9 8.5 9Z" fill="#5C5C5C"/>
                  <path className={styles.mob_fenu_icons_open_t3} d="M11.5 9C11.7761 9 12 8.77614 12 8.5C12 8.22386 11.7761 8 11.5 8C11.2239 8 11 8.22386 11 8.5C11 8.77614 11.2239 9 11.5 9Z" fill="#5C5C5C"/>
                </g>
                <defs>
                  <clipPath id="clip0_332_10301">
                    <rect width="17" height="17" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            }
          </div>
          <div className={styles.mob_fenu_icons_content}>
            {page_data.tg &&
              <a href={page_data.tg}>
                <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.18165 8.81845C2.18165 8.81845 12.0868 4.42561 15.5221 2.87879C16.839 2.26011 21.3049 0.280163 21.3049 0.280163C21.3049 0.280163 23.3661 -0.585988 23.1943 1.51761C23.137 2.38384 22.679 5.4155 22.221 8.69471C21.5339 13.3351 20.7896 18.4085 20.7896 18.4085C20.7896 18.4085 20.6751 19.8316 19.7018 20.0791C18.7284 20.3266 17.1252 19.2129 16.839 18.9654C16.6099 18.7798 12.5448 15.9956 11.0562 14.6344C10.6554 14.2632 10.1974 13.5208 11.1134 12.6545C13.1747 10.6127 15.6366 8.07604 17.1252 6.46738C17.8123 5.72488 18.4994 3.9925 15.6366 6.09609C11.5715 9.12783 7.56365 11.9739 7.56365 11.9739C7.56365 11.9739 6.64754 12.5926 4.9299 12.0358C3.21218 11.479 1.20825 10.7365 1.20825 10.7365C1.20825 10.7365 -0.165799 9.80842 2.18165 8.81845Z" fill="white"/>
                </svg>
              </a>
            }
            {page_data.phone &&
              <a href={`tel:` + page_data.phone.replace(/[-()\s]/g, '')}>
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.58279 1.73875C7.24164 0.885898 6.41563 0.32666 5.49708 0.32666H2.40744C1.2321 0.32666 0.279297 1.27923 0.279297 2.45458C0.279297 12.445 8.37836 20.544 18.3688 20.544C19.5441 20.544 20.4967 19.5912 20.4967 18.4158L20.4972 15.3257C20.4972 14.4071 19.9381 13.5812 19.0853 13.2401L16.124 12.056C15.3579 11.7496 14.4857 11.8875 13.8518 12.4157L13.0876 13.0531C12.1951 13.7969 10.8818 13.7378 10.0602 12.9162L7.90824 10.7623C7.0867 9.94073 7.02599 8.62852 7.76978 7.73598L8.40706 6.97178C8.93528 6.33791 9.07441 5.46543 8.76798 4.69933L7.58279 1.73875Z" fill="white"/>
                </svg>
              </a>
            }
          </div>
        </div>
        <div className={styles.mob_fenu_links}>
          <div onClick={changeLeftMenuh} className={styles.mob_fenu_el}>
            <div className={styles.mob_fenu_el_image}>
              {/*
              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4.2002V13.6854C1 15.0464 1 15.7268 1.20412 16.1433C1.58245 16.9151 2.41157 17.3588 3.26367 17.2454C3.7234 17.1842 4.28964 16.8067 5.4221 16.0518L5.42481 16.0499C5.87368 15.7507 6.09815 15.6011 6.33295 15.5181C6.76421 15.3656 7.23476 15.3656 7.66602 15.5181C7.90129 15.6012 8.12664 15.7515 8.57732 16.0519C9.70978 16.8069 10.2767 17.1841 10.7364 17.2452C11.5885 17.3586 12.4176 16.9151 12.7959 16.1433C13 15.7269 13 15.0462 13 13.6854V4.19691C13 3.07899 13 2.5192 12.7822 2.0918C12.5905 1.71547 12.2837 1.40973 11.9074 1.21799C11.4796 1 10.9203 1 9.8002 1H4.2002C3.08009 1 2.51962 1 2.0918 1.21799C1.71547 1.40973 1.40973 1.71547 1.21799 2.0918C1 2.51962 1 3.08009 1 4.2002Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              */}
              <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 1H1V3H3V1Z" fill="#FFFFFF"/>
                <path d="M3 5H1V7H3V5Z" fill="#FFFFFF"/>
                <path d="M1 9H3V11H1V9Z" fill="#FFFFFF"/>
                <path d="M3 13H1V15H3V13Z" fill="#FFFFFF"/>
                <path d="M15 1H5V3H15V1Z" fill="#FFFFFF"/>
                <path d="M15 5H5V7H15V5Z" fill="#FFFFFF"/>
                <path d="M5 9H15V11H5V9Z" fill="#FFFFFF"/>
                <path d="M15 13H5V15H15V13Z" fill="#FFFFFF"/>
              </svg>
              {/*favorite.length > 0 &&
                <Badge className={styles.firstng_badge + ` position-absolute top-0 start-100 translate-middle`} pill bg="danger">{favorite.length}</Badge>
              */}
            </div>
            <div className={styles.mob_fenu_el_name}>Каталог</div>
          </div>
          <div onClick={changeTopSearch} className={styles.mob_fenu_el}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5 10.5L15.5 15.5M6.33333 12.1667C3.11167 12.1667 0.5 9.55499 0.5 6.33333C0.5 3.11167 3.11167 0.5 6.33333 0.5C9.55499 0.5 12.1667 3.11167 12.1667 6.33333C12.1667 9.55499 9.55499 12.1667 6.33333 12.1667Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <div className={styles.mob_fenu_el_name}>Поиск</div>
          </div>
          <a href="/" className={styles.mob_fenu_el}>
            <Image src="./files/images/fenu.svg" width={20} height={20} alt="H" />
            <div className={styles.mob_fenu_el_name}>Главная</div>
          </a>
          <a href={page_data.cart_link} className={styles.mob_fenu_el}>
            <div className={styles.mob_fenu_el_image}>
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.7083 15.7083C14.5577 15.7083 13.625 16.6411 13.625 17.7917C13.625 18.9423 14.5577 19.875 15.7083 19.875C16.8589 19.875 17.7917 18.9423 17.7917 17.7917C17.7917 16.6411 16.8589 15.7083 15.7083 15.7083ZM15.7083 15.7083H7.68119C7.20092 15.7083 6.96034 15.7083 6.76261 15.6229C6.58818 15.5475 6.43686 15.4262 6.3266 15.2714C6.20302 15.0979 6.15332 14.866 6.05494 14.4068L3.49113 2.44234C3.39046 1.97254 3.33945 1.73789 3.21444 1.56242C3.10418 1.40766 2.95288 1.28585 2.77845 1.21047C2.58068 1.125 2.34145 1.125 1.86097 1.125H1.125M4.25 4.25H17.6596C18.4115 4.25 18.787 4.25 19.0393 4.40662C19.2604 4.54382 19.4222 4.75898 19.4928 5.00938C19.5733 5.29524 19.4698 5.65621 19.2614 6.3786L17.8191 11.3786C17.6945 11.8105 17.6322 12.0261 17.5058 12.1863C17.3942 12.3278 17.2471 12.4385 17.0803 12.5065C16.8918 12.5833 16.6678 12.5833 16.2209 12.5833H6.05257M6.33333 19.875C5.18274 19.875 4.25 18.9423 4.25 17.7917C4.25 16.6411 5.18274 15.7083 6.33333 15.7083C7.48393 15.7083 8.41667 16.6411 8.41667 17.7917C8.41667 18.9423 7.48393 19.875 6.33333 19.875Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              {cart.length > 0 &&
                <Badge className={styles.firstng_badge + ` position-absolute top-0 start-100 translate-middle`} pill bg="danger">{cart.length}</Badge>
              }
            </div>
            <div className={styles.mob_fenu_el_name}>Корзина</div>
          </a>
          <a href={page_data.kabinet_link} className={styles.mob_fenu_el}>
            <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.5 17.583C13.5 15.1898 10.5899 13.2497 7 13.2497C3.41015 13.2497 0.5 15.1898 0.5 17.583M7 9.99967C4.60677 9.99967 2.66667 8.05958 2.66667 5.66634C2.66667 3.27311 4.60677 1.33301 7 1.33301C9.39323 1.33301 11.3333 3.27311 11.3333 5.66634C11.3333 8.05958 9.39323 9.99967 7 9.99967Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <div className={styles.mob_fenu_el_name}>Профиль</div>
          </a>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  changeLeftMenuh: PropTypes.func,
  changeTopSearch: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  page_data: PropTypes.object
}